export default __webpack_public_path__ + "assembly11a96da9.png";